import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'
import DistrictTitleTopic from '../../../../components/TitleTopic/_views/DistrictTitleTopic'
import Block from '../../../../layouts/Blocks'
import ItemArticle from '../../../Article/components/ItemArticle'
import { withRouter } from 'react-router'
import LoadMore from '../../../../components/LoadMore'
import ReactGA from 'react-ga'
import pushEventToDataLayer from '../../../../modules/push-event-to-data-layer'

const Wrapper = styled.div``

const ListDistrict = ({ data: { title, id, articles, identifier }, ...props }) => {
  const trackCategory = 'district'
  ReactGA.event({ category: trackCategory, action: 'view', label: identifier })
  const trackedArticles = articles.map((article) => {
    article.track = {
      category: 'district',
      label: identifier,
    }
    return article
  })
  const [helperArticles, setArticles] = useState(trackedArticles)
  return (
    <Wrapper {...props}>
      <DistrictTitleTopic title={title} district={identifier} id={id} />
      <Block data={{ articles: [helperArticles[0]] }} adIds={['S3', 'S4']} view="big_article" />
      <Block
        data={{ articles: [helperArticles[1], helperArticles[2], helperArticles[3]] }}
        view="three_landscape_article"
        adIds={props.theme.mode === 'tablet' ? ['S5', 'S6'] : ['S5']}
      />
      <Block
        data={{ articles: [helperArticles[4], helperArticles[5], helperArticles[6]] }}
        view="three_landscape_article"
        adIds={props.theme.mode !== 'tablet' && ['S6']}
      />
      <Block data={{ articles: helperArticles.slice(7) }} view="articles" />
      <LoadMore
        articles={articles}
        afterLoadMore={(newArticles) => {
          setArticles(newArticles)
        }}
      />
    </Wrapper>
  )
}

ListDistrict.propTypes = {
  data: PropTypes.shape({
    ...DistrictTitleTopic.propTypes,
    articles: PropTypes.arrayOf(ItemArticle.propTypes.article),
  }),
}

export default withRouter(withTheme(ListDistrict))
